import { ReactElement } from "react";
import {
	FormattedText,
	Typography
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { isNotNilOrEmpty, setTrackingId } from "client/Misc/utils";
import { getComputedDisplayName } from "client/Features/AddressBook/common";
import { InlineIcon } from "./InlineIcon/InlineIcon";
import { CommunityPostCommentMentionNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { preparePostTitleAndComment } from "./CommunityPostActivity";

export type CommunityPostCommentMentionActivityProps = {
	data: CommunityPostCommentMentionNotificationDataViewModel;
};

export const CommunityPostCommentMentionActivity = (props: CommunityPostCommentMentionActivityProps): ReactElement => {
	const { data } = props;
	const {
		firstname,
		lastname,
		postMessagePreview
	} = data;

	const preparedPostTitleAndComment: string = preparePostTitleAndComment(postMessagePreview ?? "");

	const { computedDisplayName } = getComputedDisplayName({
		firstName: firstname,
		lastName: lastname
	});

	return (
		<span>
			<InlineIcon
				icon={{
					kind: "font",
					name: "at",
					color: "primary"
				}}
			/>
			<span {...setTrackingId("title")}>
				<FormattedText
					text={
						localize(
							isNotNilOrEmpty(preparedPostTitleAndComment)
								? "_UserXMentionedYouInACommentOnThePostTitleY"
								: "_UserXMentionedYouInACommentOnAPost"
						)
					}
					thingsToReplace={[
						{
							what: "{{Username}}",
							filler: (
								<Typography
									trackingId="name"
									weight="bold"
								>
									{computedDisplayName}
								</Typography>
							)
						},
						{
							what: "{{Post}}",
							filler: (
								<Typography
									trackingId="message"
									weight="bold"
								>
									{preparedPostTitleAndComment}
								</Typography>
							)
						}
					]}
				/>
			</span>
		</span>
	);
};

CommunityPostCommentMentionActivity.displayName = "CommunityPostCommentMentionActivity";